import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const polarisProductDatesSettingsEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-polaris-settings-dates", jiraSpaEntry: "async-polaris-ideas" */ './src'
			),
	),
	getPreloadProps: () => ({}),
});
